import 'react-hot-loader/patch';

import React                              from 'react';
import { AppContainer as ReactHotLoader } from 'react-hot-loader';
import { Provider }                       from 'react-redux';
import { render }                         from 'react-dom';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk                                     from 'redux-thunk';

import Root         from '../flex_rigid_flex_circuit_boards/containers/Root';
import Cart         from '../flex_rigid_flex_circuit_boards/containers/Cart';
import reducer      from '../flex_rigid_flex_circuit_boards/reducers';
import DefaultState from '../flex_rigid_flex_circuit_boards/data/DefaultState';

const middleware = [thunk];

let composeEnhancers;
if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  composeEnhancers = compose;
}
// const composeEnhancers = compose;

const store = createStore(
  reducer,
  DefaultState,
  composeEnhancers(applyMiddleware(...middleware)),
);

const renderApp = (Component, targetId = 'quote-form') => {
  render(
    <ReactHotLoader>
      <Provider store={store}>
        <Component />
      </Provider>
    </ReactHotLoader>,
    document.getElementById(targetId),
  );
};

document.addEventListener('DOMContentLoaded', () => {
  renderApp(Root);
  renderApp(Cart, 'cart-form');
});

if (module.hot) {
  module.hot.accept(
    ['../flex_rigid_flex_circuit_boards/containers/Root', '../flex_rigid_flex_circuit_boards/containers/Cart', '../flex_rigid_flex_circuit_boards/reducers'],
    () => renderApp(Root),
  );
}
